import Icon from '../SvgIcon';

const CheckboxIcon = () => (
  <Icon width={24} height={24} fill='none'>
    <rect
      xmlns='http://www.w3.org/2000/svg'
      x='1'
      y='1'
      width='22'
      height='22'
      rx='3'
      stroke='currentColor'
      strokeWidth='2'
      fill='none'
    />
  </Icon>
);

export default CheckboxIcon;
